<script>
  import Layout from "../../Layout/Layout.svelte";
  import config from "../../stores/config";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";
  import SupplierRow from "./SupplierRow.svelte";
  import { Wave } from "svelte-loading-spinners";
  import { link } from "svelte-spa-router";
  import MenuHeading from "../../shared/MenuHeading.svelte";

  let suppliers = null;
  let queryURL = "";

  let page = 1;
  let searchKey = "";

  const fetchSuppliers = () => {
    suppliers = null;

    queryURL = `${$config.backendURL}/suppliers/page/${page}?`;
    queryURL += `&searchKey=${searchKey || ""}`;

    axios
      .get(queryURL)
      .then((res) => {
        suppliers = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchSuppliers();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchSuppliers();
  };

  const handleRefresh = () => {
    page = 1;
    searchKey = "";
    fetchSuppliers();
  };

  onMount(() => {
    fetchSuppliers();
  });
</script>

<svelte:head>
  <title>Suppliers — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  {#if $config.currentUser}
    {#if $config.currentUser.department == "Management"}
      <MenuHeading title="Suppliers" description="Manage Suppliers " />

      <!-- Search Bar -->
      <div class="flex justify-between">
        <div class="flex justify-center">
          <input
            bind:value={searchKey}
            on:input={fetchSuppliers}
            class="shadow-sm"
            type="text"
            placeholder="Enter an supplier..."
          />
          <button class="ml-2 btn btn-primary" on:click={fetchSuppliers}>
            <i class="fas fa-search" />
          </button>
        </div>
        <div class="flex items-center">
          <button class="btn btn-green mr-4" on:click={handleRefresh}>
            <i class="fas fa-undo mr-3" />
            Refresh
          </button>
          <a class="btn btn-primary" use:link href="/addsupplier">
            <i class="fas fa-plus-circle mr-3" />
            Add Supplier
          </a>
        </div>
      </div>

      <!-- Products Bar -->
      <div
        class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
      >
        <div class="th  border-b border-gray-100 font-semibold text-gray-600">
          <h1 style="min-width: 10rem; max-width: 10rem;">Actions</h1>
          <h1 style="min-width: 20rem; max-width: 20rem;">Name</h1>
          <h1 style="min-width: 10rem; max-width: 10rem;">Telephone</h1>
          <div style="min-width: 15rem; max-width: 15rem;">Email</div>
          <div style="min-width: 25rem; max-width: 25rem;">Address</div>
        </div>

        {#if suppliers}
          {#each suppliers as supplier (supplier._id)}
            <SupplierRow {...supplier} on:delete={fetchSuppliers} />
          {:else}
            <div class="h-52 w-full flex items-center justify-center">
              Nothing to show...
            </div>
          {/each}
        {:else}
          <div class="h-52 w-full flex items-center justify-center">
            <Wave size="50" color="rgb(244,162,97)" unit="px" />
          </div>
        {/if}

        <div class="tf">
          <button
            class="text-base btn btn-gray-outline"
            on:click={handlePrevPage}
          >
            <i class="fas fa-arrow-alt-circle-left mr-3" />
            Prev Page
          </button>
          <div class="mx-4">Page {page}</div>
          <button
            class="text-base btn btn-gray-outline"
            on:click={handleNextPage}
          >
            Next Page
            <i class="fas fa-arrow-alt-circle-right ml-3" />
          </button>
        </div>
      </div>
    {/if}
  {/if}
</Layout>

<style>
  .th,
  .tf {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
